import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopHeaderComponent } from './components/top-header/top-header.component';
import { TermsConditionComponent } from './components/terms-condition/terms-condition.component';
import { TranslocoModule } from '@jsverse/transloco';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicControlsComponent } from '../Modules/management/components/modals/organization/dynamic-controls/dynamic-controls.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { PrintReportsComponent } from '../Modules/idms/components/plant-manager/components/print-reports/print-reports.component';
import { DynamicAlignmentControlComponent } from '../Modules/management/components/modals/organization/dynamic-alignment-control/dynamic-alignment-control.component';
import {
    DxButtonModule,
    DxCircularGaugeModule,
    DxDateBoxModule,
    DxDiagramModule,
    DxLinearGaugeModule,
    DxNumberBoxModule,
    DxPopupModule,
    DxSliderModule,
    DxTemplateModule,
    DxTextBoxModule,
} from 'devextreme-angular';
import { JointTighteningGenericComponent } from '../Modules/management/components/modals/organization/joint-tightening-generic/joint-tightening-generic.component';
import { SelectButtonModule } from 'primeng/selectbutton';
//import { AvatarModule } from 'ngx-avatars';
import { DocumentsComponent } from '../Modules/idms/components/project-manager/components/documents/documents.component';
import { ProjectManagerListModalComponent } from '../Modules/idms/components/project-manager/modals/project-manager-list-modal/project-manager-list-modal.component';
import { InfoDialogsModule } from './info-dialogs/info-dialogs.module';
import { DndModule } from 'ngx-drag-drop';
import { FlowchartComponent } from '../Modules/management/components/flowchart/flowchart.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { SharedPipeModule } from './shared-pipe.module';
import { BlockDateTypingDirective } from './directive/block-date-typing.directive';
import { TruncatePipe } from '../Modules/idms/components/plant-manager/Pipes/truncate.pipe';

@NgModule({
    declarations: [
        TopHeaderComponent,
        TermsConditionComponent,
        DynamicControlsComponent,
        PrintReportsComponent,
        DynamicAlignmentControlComponent,
        JointTighteningGenericComponent,
        DocumentsComponent,
        ProjectManagerListModalComponent,
        FlowchartComponent,
        BlockDateTypingDirective, //Added 'blockDateTyping' directive to block typing in dx-datepicker
        TruncatePipe, //Added to truncate the lengthy texts to ellipsis
    ],
    imports: [
        CommonModule,
        TranslocoModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        NgbCarouselModule,
        DxCircularGaugeModule,
        DxLinearGaugeModule,
        DxSliderModule,
        DxNumberBoxModule,
        SelectButtonModule,
        //AvatarModule,
        InfoDialogsModule,
        //AvatarModule,
        DndModule,
        DxDiagramModule,
        DxTemplateModule,
        NgxPaginationModule,
        NgxMaskDirective,
        NgxMaskPipe,
        SharedPipeModule,
        DxDateBoxModule,
        DxPopupModule,
        DxTextBoxModule,
        DxButtonModule,
    ],
    exports: [
        TopHeaderComponent,
        DynamicControlsComponent,
        DynamicAlignmentControlComponent,
        DxCircularGaugeModule,
        DxLinearGaugeModule,
        DxSliderModule,
        //AvatarModule,
        PrintReportsComponent,
        DocumentsComponent,
        ProjectManagerListModalComponent,
        DndModule,
        FlowchartComponent,
        NgxPaginationModule,
        NgxMaskDirective,
        NgxMaskPipe,
        DxDateBoxModule,
        BlockDateTypingDirective,
        TruncatePipe,
    ],
    providers: [provideNgxMask()],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
